"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Modal.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Modals are used for displaying content to the user in a separate section
 * while disabling all other content on the page. When the modal is displayed,
 * it disables background scrolling, and moves focus into the modal.
 *
 * The Modal is rendered via a React portal, and exists outside of the DOM order
 * of the JSX tree it is associated with. This helps avoid z-index related
 * errors and improves accessibility.
 *
 * Modal visibility is handled entirely by the render tree — If the Modal is
 * mounted, it is considered active & visible. To hide a modal, simply unmount
 * it. An `onClose` prop is available, which will allow the user to request to
 * close the modal by clicking on the background, the close button, or pressing
 * ESC. This `onClose` handler can be used to update state and conditionally
 * render the modal within your app.
 */
const Modal = ({
  children,
  container,
  footer,
  header,
  initialFocus,
  zIndex,
  fullScreen,
  onClose,
  variant = 'fullscreen',
  ...otherProps
}) => {
  const modalEl = React.useRef(null);
  const [transitionState, animateUnmount] = (0, _.useAnimateUnmount)(modalEl, onClose);
  const handleClose = onClose ? animateUnmount : undefined;
  const isSidebar = variant === 'sidebar';
  return (0, _pragma.createFelaElement)(_.BaseModal, {
    container: container,
    initialFocus: initialFocus,
    onClose: handleClose,
    transitionState: transitionState,
    zIndex: zIndex,
    disableFocusTrap: !initialFocus,
    variant: variant
  }, (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.base,
    cssProps: {
      isSidebar,
      fullScreen,
      transitionState
    },
    flexDirection: "column",
    justifyContent: "space-between" // TODO: get rid of ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    ref: modalEl
  }, otherProps), header && (0, _pragma.createFelaElement)(_.View, {
    css: css.header,
    gap: "small",
    justifyContent: "space-between",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.View, {
    css: css.headerIcons,
    justifyContent: "flex-start"
  }, onClose && (0, _pragma.createFelaElement)(_.ButtonIcon, {
    "aria-label": "Close Dialog",
    onClick: handleClose,
    variant: "secondary"
  }, (0, _pragma.createFelaElement)(_.CloseIcon, {
    size: "small"
  }))), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    color: "text.1",
    children: header === null || header === void 0 ? void 0 : header.title
  }), (0, _pragma.createFelaElement)(_.View, {
    css: css.headerIcons,
    justifyContent: "flex-end"
  }, header === null || header === void 0 ? void 0 : header.rightIcon)), (0, _pragma.createFelaElement)(_.View, {
    children: children,
    css: css.content,
    cssProps: {
      isSidebar
    },
    flexWrap: "wrap"
  }), footer && (0, _pragma.createFelaElement)("div", {
    children: footer,
    css: css.footer
  })));
};

Modal.displayName = 'Modal';
var _default = Modal;
exports.default = _default;
//# sourceMappingURL=Modal.js.map